import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { useAppContext } from "../../../../../../../context";
import { ConstantFormat } from "../../../../../../../utils/DateFns";
import { CellContentRoot } from "..";

const ExecutingStageArrivedTimeCellContent: React.FC<
	ExecutingStageArrivedTimeCellContent.Props
> = ({ item }) => {
	const { dateFns } = useAppContext();

	const { content } = useMemo(() => {
		const timestamp = item?.executingStages?.arrived?.timestamp;
		const content =
			timestamp && dateFns
				? dateFns.formatTime(timestamp, {
						formatTime: ConstantFormat.HMS_UK,
						isTimezone: true,
				  })
				: "";
		return { content };
	}, [item?.executingStages?.arrived?.timestamp, dateFns]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ExecutingStageArrivedTimeCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default ExecutingStageArrivedTimeCellContent;
